import React, { Component } from 'react';
import Grid from '../../Utils/GridFiltro';
import PropTypes from 'prop-types';
import { standardActions } from '../../Utils/Grid/StandardActions';
const valEmp = __CONFIG__.empresa;

class PaisList extends Component{
    static propTypes = {
        data: PropTypes.object.isRequired,
        loader: PropTypes.bool.isRequired,
        //onPageChange: PropTypes.func,
        onSortChange: PropTypes.func,
    };

    static defaultProps = {
        loading: true
    };

    componentDidMount = () => {
        const { listar } = this.props;
        listar();
    }
    render(){
        const { data, loader, eliminar } = this.props;
        let ruta = window.location.href;
        let id_emp = ruta.split('/');
        return(
            <React.Fragment>
                <br />
                <h3 className="p-2 bg-secondary title">Paises</h3>
                <br />
                {valEmp === 'fage' &&
                    <div className="d-flex flex-row justify-content-start mb-2">
                        <a
                            href={`/#/lfg/rr_hh/${id_emp[6]}/pais/crear`}
                            className='btn btn-primary'
                        >
                            Crear pais
                        </a>
                    </div>
                }
                {valEmp === '' &&
                    <div className="d-flex flex-row justify-content-start mb-2">
                        <a
                            href={`/#/rr_hh/${id_emp[5]}/pais/crear`}
                            className='btn btn-primary'
                        >
                            Crear pais
                        </a>
                    </div>
                }
                {data &&
                    <Grid 
                        hover 
                        striped 
                        data={data}
                        loading={loader} 
                        headerStyle={ { background: 'black' } } 
                        //onPageChange={onPageChange}
                        //onSortChange={onSortChange} 
                    >
                        <TableHeaderColumn
                            isKey
                            dataField="pais"
                            dataAlign='left'
                            dataSort
                            thStyle={
                                {color: 'white'}}
                            tdStyle={
                                {color: 'white'}}
                        >
                            Pais
                        </TableHeaderColumn>
                        <TableHeaderColumn
                            thStyle={
                            {color: 'white'}}
                            dataField="id"
                            dataAlign="center"
                            dataSort
                            dataFormat={standardActions({ 
                                editar: "pais", 
                                ver: "pais",
                            })} 
                            
                        >
                            Acciones
                        </TableHeaderColumn>
                        {valEmp === 'fage' &&
                            <TableHeaderColumn
                                thStyle={
                                {color: 'white'}}
                                dataField="id"
                                dataAlign="center"
                                dataSort
                                dataFormat={standardActions({ 
                                    asignar_tipo_documento_lfg: "asignar_tipo_documento",
                                    empresa: id_emp[6],
                                    modulo: id_emp[5],
                                })} 
                            
                            >
                                Documentos
                            </TableHeaderColumn>
                        }
                        {valEmp === '' &&
                            <TableHeaderColumn
                                thStyle={
                                {color: 'white'}}
                                dataField="id"
                                dataAlign="center"
                                dataSort
                                dataFormat={standardActions({ 
                                    asignar_tipo_documento: "asignar_tipo_documento",
                                    empresa: id_emp[5],
                                    modulo: id_emp[4],
                                })} 
                            
                            >
                                Documentos
                            </TableHeaderColumn>
                        }
                        
                    </Grid>
                }
            </React.Fragment>
        );
    }
}

export default PaisList;
